"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const SongwriterCatalogEmptyWarning_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogScene/SongwriterCatalogEmptyWarning"));
const contexts_1 = require("@App/contexts");
const CatalogSearch_1 = __importDefault(require("@Components/CatalogSearch"));
const SongwriterCatalogCompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/SongwriterCatalogCompactWorkItem"));
const SongwriterCatalogExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/SongwriterCatalogExtendedWorkItem"));
const SongwriterCatalogHeader_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogScene/SongwriterCatalogHeader"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const SongwriterHubWelcomePopup_1 = __importDefault(require("@Components/Popups/SongwriterHubWelcomePopup"));
require("./index.scss");
const form_field_types_1 = require("@App/enum/form-field-types");
const SongwriterCatalogScene = () => {
    const { songwriterCatalogSearchStore, songwriterStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const userSettings = userStore.userSettings;
    const [hasWriters, setHasWriters] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [showFirstTimeSongwriterHubPopup, setShowFirstTimeSongwriterHubPopup] = (0, react_1.useState)(!!(userSettings && userSettings.showSongwriterHubPopup));
    const songwriterSearchFilters = [
        {
            name: 'Songs',
            allowMultiple: false,
            filterFields: [
                {
                    MLC_SONGWRITER_HUB: {
                        type: form_field_types_1.FormFieldTypes.CHECKBOX,
                        checked: false,
                        name: 'hasUnclaimedShare',
                        label: '',
                        children: 'Show only partially claimed songs',
                    },
                },
            ],
        },
    ];
    (0, react_1.useEffect)(() => {
        songwriterStore
            .loadSongwriterSummary()
            .then(() => setHasWriters(songwriterStore.songwriterSummary.totalWorks > 0))
            .finally(() => setLoading(false));
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Song Catalog' }),
        react_1.default.createElement("div", { className: "songwriter-catalog-wrapper" },
            react_1.default.createElement(ContentHeader_1.default, { title: 'Song Catalog', content: react_1.default.createElement(SongwriterCatalogHeader_1.default, null) }),
            loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : hasWriters ? (react_1.default.createElement(CatalogSearch_1.default, { userStore: userStore, catalogSearchStore: songwriterCatalogSearchStore, compactWorkComponentType: SongwriterCatalogCompactWorkItem_1.default, extendedWorkComponentType: SongwriterCatalogExtendedWorkItem_1.default, searchFilters: songwriterSearchFilters })) : (react_1.default.createElement(SongwriterCatalogEmptyWarning_1.default, { currentSongwriterId: songwriterStore.currentSongwriterId }))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: showFirstTimeSongwriterHubPopup },
            react_1.default.createElement(SongwriterHubWelcomePopup_1.default, { onClose: () => setShowFirstTimeSongwriterHubPopup(false), songwriterId: songwriterStore.currentSongwriterId }))));
};
exports.default = SongwriterCatalogScene;
